import React, { Component } from "react";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { hideLoading, setLoaderClass, showLoading } from "@my-dld/utils/UIUtils";

interface Props {
	url: string;
	onDismiss: () => void;
}

interface State {

	isLoading?: boolean;
}

class PaymentFrame extends Component<Props, State> {

	constructor( props: Props ) {
		super( props );

		this.state = {};
	}

	componentDidMount() {
		setLoaderClass( "mydld-loader-on-top" );
		showLoading();
	}

	componentWillUnmount() {
		setLoaderClass( undefined );
	}

	render() {
		let { url } = this.props;
		return (
			<Popup
				id={ "payment" } showIcon={ false } autoOpenMount={ true }
				clickOutsideToDismiss={ false } contentHeight={ "80vh" } width={ "90vw" }
				onDismiss={ this.props.onDismiss }
			>
				<iframe
					src={ url } height={ "100%" } width={ "100%" } onLoad={ () => {
					hideLoading();
				} }/>
				<div className="relative spinner-border " role="status">
					<span className="sr-only">Loading...</span>
				</div>
			</Popup>
		);
	}

	dismiss() {
		JQModal( "payment" ).hide();
	}

}

export default PaymentFrame;
